export enum OPCO_ID {
  BAEC = 'baec',
  VYC = 'vyc',
  IBP = 'ibp',
  EIC = 'eic',
  BA = 'BA',
  IB = 'IB',
  EI = 'EI',
}

export enum OPCO {
  BAEC = 'ba', // Future DELETE
  VYC = 'vueling',
  IBP = 'iberia',
  EIC = 'aerclub',
  BA = 'BA',
  EI = 'EI',
  IB = 'IB',
}

export enum MARKET_ID {
  US = '1',
  FR = '72',
  IE = '101',
  IT = '103',
  ES = '190',
  GB = '216',
}

export enum AVAILABLE_MARKETS {
  US = 'US',
  IE = 'IE',
  ES = 'ES',
  GB = 'GB',
}

export enum LOCALE_ID {
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  EN_IE = 'en-IE',
  ES_ES = 'es-ES',
}

export const DESIGN_TOKENS_OPCO_ID = {
  [OPCO_ID.BAEC]: 'british-airways',
  [OPCO_ID.BA]: 'avios',
  [OPCO_ID.IB]: 'avios',
  [OPCO_ID.VYC]: 'vueling',
  [OPCO_ID.IBP]: 'iberia',
  [OPCO_ID.EIC]: 'aer-lingus',
  [OPCO_ID.EI]: 'avios',
};

export const getCBRProgramID: Record<OPCO_ID, number> = {
  [OPCO_ID.BAEC]: 1,
  [OPCO_ID.EIC]: 2,
  [OPCO_ID.VYC]: 3,
  [OPCO_ID.IBP]: 4,
  [OPCO_ID.BA]: 1,
  [OPCO_ID.IB]: 4,
  [OPCO_ID.EI]: 2,
};

export type GTM_ID_TYPE = {
  default: string;
  live: string;
  thirdParty?: string;
};

export type ONE_TRUST_COOKIES_TYPE = {
  test: string;
  live: string;
};
